module.exports = __webpack_public_path__ + "static/media/silicon.c5a53d07.jpeg";